import Cookies from 'js-cookie';

const CleanAllCookies = () => {
  const allCookies = Cookies.get();
  const cookiesWereDeleted = Cookies.get('cookiesWereDeleted');
  const isActive = document.querySelector('[data-clean-cookies="true"]');

  if (!cookiesWereDeleted && isActive) {
    Object.keys(allCookies).forEach(cookie => {
      Cookies.remove(cookie);
    });
    Cookies.set('cookiesWereDeleted', true, {
      expires: 365,
      path: '/',
      sameSite: 'strict'
    });
  }
};

export default CleanAllCookies;
